// extracted by mini-css-extract-plugin
module.exports = {"mpcGrid":"_c3ea2f7"};